import React from "react";

function Term(props) {
  return (
    <div className="max-w-7xl mx-auto px-4 lg:px-0 bg-white pt-20">
      <h1 className="text-4xl lg:text-5xl">Terms and Conditions</h1>
      <h1 className="text-3xl lg:text-4xl mb-2 mt-10">Introduction</h1>

      <p className="text-sm lg:text-base text-[#374D5D]">
        Welcome to Hallimo! These Terms and Conditions ("Terms") govern your
        access to and use of Hallimo's platform, services, and content. By
        accessing or using the platform, you agree to be bound by these Terms.
        If you do not agree to these Terms, you must not use the platform.
      </p>

      <h1 className="text-3xl lg:text-4xl mb-2 mt-10">1. Definitions</h1>
      <div className="md:px-5">
        <ul>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              <b>"Platform"</b> refers to the Hallimo website, apps, and all
              associated services.
            </p>
          </li>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              <b>"User"</b> refers to individuals or organizations accessing
              Hallimo, including learners, patrons, and supporters.
            </p>
          </li>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              <b>"Rewards"</b> refers to tangible or intangible benefits,
              including discounts, gifts, internships, or other incentives
              offered through the platform.
            </p>
          </li>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              <b>"Content"</b> includes quizzes, contests, rewards, logos, text,
              images, and other material provided by Hallimo.
            </p>
          </li>
        </ul>
      </div>

      <h1 className="text-3xl lg:text-4xl mb-2 mt-10">2. Eligibility</h1>
      <div className="md:px-5">
        <ul>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              Users must be at least 13 years old to register on the platform.
            </p>
          </li>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              If you are under 18, you must have parental or guardian consent to
              use Hallimo.
            </p>
          </li>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              By using Hallimo, you confirm that all information provided during
              registration is accurate and complete.
            </p>
          </li>
        </ul>
      </div>

      <h1 className="text-3xl lg:text-4xl mb-2 mt-10">
        3. Use of the Platform
      </h1>
      <div className="md:px-5">
        <ul>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              You agree to use Hallimo only for lawful purposes and in
              compliance with these Terms.
            </p>
          </li>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              Prohibited activities include but are not limited to:
            </p>

            <ul className="custom-outlined-list pl-4 md:pl-8">
              <li className="text-sm lg:text-base text-[#374D5D]">
                Cheating or manipulating quizzes, contests, or rewards systems.
              </li>
              <li className="text-sm lg:text-base text-[#374D5D]">
                Violating any applicable laws or regulations.
              </li>
              <li className="text-sm lg:text-base text-[#374D5D]">
                Uploading or sharing harmful, offensive, or illegal content.
              </li>
              <li className="text-sm lg:text-base text-[#374D5D]">
                Attempting to disrupt the platform through hacking, malware, or
                other malicious activities.
              </li>
            </ul>
          </li>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              Any misuse of the platform may result in suspension or termination
              of your account.
            </p>
          </li>
        </ul>
      </div>

      <h1 className="text-3xl lg:text-4xl mb-2 mt-10">4. Rewards</h1>
      <div className="md:px-5">
        <ul>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              Rewards earned through the platform are subject to verification
              and availability.
            </p>
          </li>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              Hallimo reserves the right to modify, substitute, or cancel
              rewards at any time without prior notice.
            </p>
          </li>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              Users are responsible for any taxes, duties, or fees associated
              with redeeming rewards.
            </p>
          </li>
        </ul>
      </div>

      <h1 className="text-3xl lg:text-4xl mb-2 mt-10">
        5. Subscription Services
      </h1>
      <div className="md:px-5">
        <ul>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              Hallimo does not currently offer subscriptions. However, if
              subscription services are introduced in the future, these Terms
              will be updated to include details about subscription fees,
              payment terms, cancellation policies, and refund eligibility.
            </p>
          </li>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              Continued use of the platform following the introduction of
              subscriptions will constitute acceptance of the updated terms.
            </p>
          </li>
        </ul>
      </div>

      <h1 className="text-3xl lg:text-4xl mb-2 mt-10">6. Patron Program</h1>
      <div className="md:px-5">
        <ul>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              Contributions made under the Patron Program are non-refundable.
            </p>
          </li>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              Benefits such as revenue sharing, advertisements, recognition and
              others are provided based on the contribution tiers outlined in
              the Patron Program.
            </p>
          </li>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              Lifetime premium accounts are valid from the date of contribution
              and remain subject to updates in our service offerings.
            </p>
          </li>
        </ul>
      </div>

      <h1 className="text-3xl lg:text-4xl mb-2 mt-10">
        7. Intellectual Property
      </h1>
      <div className="md:px-5">
        <ul>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              All content on the platform is owned by Hallimo or its licensors.
            </p>
          </li>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              Users are granted limited, non-exclusive rights to use the
              platform for personal, non-commercial purposes.
            </p>
          </li>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              Unauthorized reproduction, distribution, or modification of
              Hallimo's content is prohibited.
            </p>
          </li>
        </ul>
      </div>

      <h1 className="text-3xl lg:text-4xl mb-2 mt-10">
        8. Intellectual Property
      </h1>
      <p className="text-sm lg:text-base text-[#374D5D]">
        Your use of Hallimo is also governed by our Privacy Policy, which
        explains how we collect, use, and protect your personal data.
      </p>

      <h1 className="text-3xl lg:text-4xl mb-2 mt-10">
        9. Limitation of Liability
      </h1>
      <div className="md:px-5">
        <ul>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              Hallimo provides the platform and services "as is" and does not
              guarantee uninterrupted or error-free operation.
            </p>
          </li>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              Hallimo is not responsible for:
            </p>

            <ul className="custom-outlined-list pl-4 md:pl-8">
              <li className="text-sm lg:text-base text-[#374D5D]">
                Losses or damages resulting from technical issues, data
                breaches, or user errors.
              </li>
              <li className="text-sm lg:text-base text-[#374D5D]">
                The accuracy or reliability of user-generated content.
              </li>
            </ul>
          </li>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              To the fullest extent permitted by law, Hallimo disclaims all
              liability for direct, indirect, or consequential damages arising
              from your use of the platform.
            </p>
          </li>
        </ul>
      </div>

      <h1 className="text-3xl lg:text-4xl mb-2 mt-10">
        10. Dispute Resolution and Governing Law
      </h1>
      <p className="text-sm lg:text-base text-[#374D5D]">
        These Terms are governed by the laws of Nigeria. In the event of a
        dispute arising from or related to the use of Hallimo, users agree to
        first resolve the issue through binding arbitration in accordance with
        the Arbitration and Conciliation Act of Nigeria. If arbitration fails to
        resolve the dispute, users may pursue legal action in the courts of
        Nigeria, which shall have exclusive jurisdiction.
      </p>

      <h1 className="text-3xl lg:text-4xl mb-2 mt-10">
        11. Changes to the Terms
      </h1>
      <p className="text-sm lg:text-base text-[#374D5D]">
        Hallimo reserves the right to modify these Terms and Conditions at any
        time. Changes will be communicated via the platform, and continued use
        of the platform constitutes acceptance of updated Terms.
      </p>

      <h1 className="text-3xl lg:text-4xl mb-2 mt-10">12. Termination</h1>
      <div className="md:px-5">
        <ul>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              Hallimo may suspend or terminate your account without prior notice
              if you violate these Terms or engage in prohibited activities.
            </p>
          </li>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              Users may terminate their accounts at any time by contacting
              <b>info@hallimo.com.</b>
            </p>
          </li>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              Termination does not absolve users of any obligations incurred
              prior to termination.
            </p>
          </li>
        </ul>
      </div>

      <h1 className="text-3xl lg:text-4xl mb-2 mt-10">
        13. Contact Information
      </h1>
      <p className="text-sm lg:text-base text-[#374D5D]">
        For questions, concerns, or support, you can contact us at:
      </p>
      <p className="text-sm lg:text-base text-[#374D5D]">
        <b>Email:</b> info@hallimo.com
      </p>
      <p className="text-sm lg:text-base text-[#374D5D]">
        <b>Phone:</b> +2348066610436
      </p>
      <p className="text-sm lg:text-base text-[#374D5D]">
        <b>Address:</b> 155 Old Odukpani Road, Calabar
      </p>
      <p className="text-sm lg:text-base text-[#374D5D]">
        By using Hallimo, you acknowledge that you have read, understood, and
        agree to be bound by these Terms and Conditions.
      </p>
    </div>
  );
}

export default Term;
